/**
 * Product card — variant select syncs price, availability, and quantity rules.
 */
(function () {
  function formatCardPrice(cents) {
    if (window.NihooyaCart?.formatDisplayMoney) {
      return window.NihooyaCart.formatDisplayMoney(cents);
    }

    const euros = Math.floor(cents / 100);
    const remainder = cents % 100;
    const fraction = remainder < 10 ? `0${remainder}` : String(remainder);
    return `€${euros}.${fraction}`;
  }

  function updateCardFromSelect(select) {
    const card = select.closest('[data-nihooya-card]');
    if (!card) return;

    const option = select.selectedOptions[0];
    if (!option) return;

    const price = parseInt(option.dataset.price || '0', 10);
    const available = option.dataset.available === 'true';
    const minQty = parseInt(option.dataset.quantityMin || '1', 10) || 1;

    const priceWrap = card.querySelector('[data-nihooya-card-price]');
    if (priceWrap) {
      const priceEl = priceWrap.querySelector('.nihooya-product-card__price') || priceWrap;
      const fromEl = priceEl.querySelector('.nihooya-product-card__price-from');
      if (fromEl) fromEl.remove();
      priceEl.classList.remove('nihooya-product-card__price--varies');
      priceEl.textContent = formatCardPrice(price);
    }

    const qtyInput = card.querySelector('[data-nihooya-card-quantity]');
    if (qtyInput) qtyInput.value = String(minQty);

    const variantInput = card.querySelector('[name="id"]');
    if (variantInput && select.value) variantInput.value = select.value;

    const submitButton = card.querySelector('.nihooya-product-card__add[type="submit"]');
    if (submitButton) {
      submitButton.disabled = !available;
      submitButton.removeAttribute('aria-disabled');
      submitButton.querySelector('.sold-out-message')?.classList.toggle('hidden', available);
      submitButton.querySelector('.nihooya-product-card__add-icon')?.classList.toggle('hidden', !available);
    }

    const soldOutBadge = card.querySelector('.nihooya-product-card__sold-out');
    if (soldOutBadge) soldOutBadge.hidden = available;

    card.classList.toggle('nihooya-product-card--sold-out', !available);
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.nihooya-product-card__variant-select');
    if (!select) return;
    updateCardFromSelect(select);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.nihooya-product-card__variant-select').forEach(updateCardFromSelect);
  });
})();